export default [

	{
		name1: '<br>Шейн',
		text: `
			<div class="title">Из-за чего предал</div>
			<div class="text">
				Из-за женщины.
			</div>
			<div class="title">Как предал</div>
			<div class="text">
				Полицейский Шейн после апокалипсиса думал, что его напарник Рик погиб, поэтому стал заботиться о его жене и сыне. Постепенно он перестал скрывать свои чувства к жене Рика. Лори, будучи уверенной, что стала вдовой, ответила ему взаимностью. Однако вскоре Рик объявился живой и здоровый. Лори попыталась пресечь свой новый роман, но быстро забеременела, даже не зная, от кого именно. Шейн был уверен, что это его ребенок, поэтому стал мешать Лори и Рику, а в конце концов решил подло убить своего бывшего друга, а теперь соперника.
			</div>
			<div class="title">Что с этим делать?</div>
			<div class="text">
				Рик долго пытался охладить пыл Шейна, но перед смертельной опасностью пришлось решать ситуацию радикальными методами. Правда, финальную точку поставил сын Рика, который застрелил Шейна и таким образом сделал выбор между отцом и потенциальным отчимом.
			</div>
		`
	},

	{
		name1: '<br>Андреа',
		text: `
			<div class="title">Из-за чего предала</div>
			<div class="text">
				Из-за лучшей жизни.
			</div>
			<div class="title">Как предала</div>
			<div class="text">
				Одна из участниц группы Рика всегда была склонна к необдуманным поступкам — все-таки у нее в первых сезонах были сексуальные отношения с Шейном. В конце второго сезона откололась от группы после бегства с фермы, прибилась к мрачной девушке Мишонн, а затем наткнулась на поселение Вудбери, где ей так понравилось жить, что она стала любовницей Губернатора. В какой-то момент Губернатору удалось настроить Андреа против Мишонн и группы Рика.
			</div>
			<div class="title">Что с этим делать?</div>
			<div class="text">
				Андреа поплатилась за свои действия — кара пришла от самого Губернатора, который вскоре раскрылся не с самой лучшей стороны, но у нее не поднялась рука убить своего любовника. Тогда Губернатор приказывает убить Андреа в кресле для пыток.
			</div>
		`
	},

	{
		name1: '<br>Милтон',
		text: `
			<div class="title">Из-за чего предал</div>
			<div class="text">
				Не смог больше терпеть несправедливость.
			</div>
			<div class="title">Как предал</div>
			<div class="text">
				Был одним из главных помощников Губернатора и проводил опыты над людьми и зомби, будучи уверенным, что превращение в зомби — это обратимый процесс. Но Милтон разочаровался в опытах и в Губернаторе и попытался убить своего босса.
			</div>
			<div class="title">Что с этим делать?</div>
			<div class="text">
				Губернатор наказал Милтона и, перед тем как тот обратился в зомби, запер его в комнате с прикованной Андреа, чтобы оба предателя сами уничтожили друг друга.
			</div>
		`
	},

	{
		name1: '<br>Мерл',
		text: `
			<div class="title">Из-за чего предал</div>
			<div class="text">
				Злопамятный.
			</div>
			<div class="title">Как предал</div>
			<div class="text">
				В первом сезоне группа Рика бросила Мерла, не слишком приятного брата Дэрила, на крыше без всяких перспектив на выживание. Но Мерл отпилил себе руку, спасся, присоединился к Губернатору, стал воевать против группы Рика и даже пытался прикончить брата Дэрила, когда не смог его переубедить.
			</div>
			<div class="title">Что с этим делать?</div>
			<div class="text">
				В принципе, Мерл ответил предательством на предательство, а в мире «Ходячих мертвецов» вообще никто никому ничего не прощает.
			</div>
		`
	},

	{
		name1: '<br>Джедис',
		text: `
			<div class="title">Из-за чего предала</div>
			<div class="text">
				Из-за Нигана.
			</div>
			<div class="title">Как предала</div>
			<div class="text">
				Глава отряда Мусорщиков обещала Рику помочь в битве со Спасителями, но в самый ответственный момент ее команда наставила автоматы на спины ничего не подозревающих выживальцев из Александрии.
			</div>
			<div class="title">Что с этим делать?</div>
			<div class="text">
				Это был хитрый план Нигана и Спасителей, чтобы одним махом обвести вокруг пальца Рика и быстро выиграть битву. Поэтому выход тут только один — убить Нигана. Тогда все подконтрольные ему территории пойдут на попятную.
			</div>
		`
	},

	{
		name1: '<br>Юджин',
		text: `
			<div class="title">Из-за чего предал</div>
			<div class="text">
				Из-за страха.
			</div>
			<div class="title">Как предал</div>
			<div class="text">
				Инженер переметнулся из Александрии на базу Спасителей и присягнул на верность Нигану.
			</div>
			<div class="title">Что с этим делать?</div>
			<div class="text">
				Он не скрывает, что сам считает себя трусом: он сделал это только из-за того, что очень боялся погибнуть.
			</div>
		`
	},

	{
		name1: '<br>Дуайт',
		text: `
			<div class="title">Из-за чего предал</div>
			<div class="text">
				Потерял смысл.
			</div>
			<div class="title">Как предал</div>
			<div class="text">
				Один из прислужников Нигана, который беспрекословно выполняет его приказы: даже уступил свою жену в жены своему свирепому лидеру. Считал, что так ей будет безопаснее жить, а сам отдал себя на заклание Спасителям, забыв про честь, ум и совесть. Однако постепенно он стал включать голову, тайно нарушать приказы и даже проникся некоторой эмпатией к пленнику Дэрилу, которого мучил в заточении. А когда его жена сбежала из Святилища, он решил не служить Нигану и стал делиться секретной информацией с группой Рика.
			</div>
			<div class="title">Что с этим делать?</div>
			<div class="text">
				Дуайт, формально, все еще во власти Нигана, но уже желает ему смерти. Группа Рика стала верить ему только с подачи Дэрила, который не стал убивать своего мучителя. Тем не менее, после того как им удастся одолеть главного злодея, Дэрил обещает все равно убить Дуайта, как бы тот ни раскаивался.
			</div>
		`
	},

]



// WEBPACK FOOTER //
// ./src/data/slider7.js